<template>
  <div class="cart-dropdown" :class="{ 'cart-dropdown__open': open, 'cart-dropdown__opened': opened }">
    <button type="button" class="cart-dropdown__header" @click="open = opened || !open">
      <span class="cart-dropdown__title">{{ title }}</span>
      <IconComponent v-if="!opened" name="arrow-down-1" />
    </button>
    <div class="cart-dropdown__body" v-if="open">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "CartDropdownComponent",
  components: { IconComponent },
  props: {
    title: String,
    opened: Boolean,
  },
  data() {
    return {
      open: true,
    };
  },
};
</script>

<style lang="stylus">
.cart-dropdown {
  display grid
  align-items start

  &__open &__header {
    .icon {
      transform rotate(180deg)
    }
  }

  &:not(&__opened) &__header {
    cursor pointer

    &:hover {
      color var(--main-color-75)
    }
  }

  &__header {
    padding-bottom 15px
    display flex
    align-items center
    justify-content space-between
    border none
    background none
    font-weight: 700;
    font-size: 1.125em
    line-height: 140%;
    //color: var(--main-color)
    border-bottom 1px solid var(--gray)

    .icon {
      width 16px
      height: 16px
    }
  }

  &__title {
    display: flex;
    align-items: center;
    text-align left
    transition color var(--transition)
  }

  &__body {
    padding-top 30px
    display grid
    grid-gap 20px
  }
}
</style>
